module.exports = "../images/forest.jpg?v=76d298b";